export default (ctx, key) => {
  let strings = {
    "policies_not_agreed": "You MUST agree to the Terms and Conditions, Privacy Policy, Cookie Policy and Acceptable use Policy",
    "email_updated": "Email updated successfully, Please enter verification code sent to the new email",
    "phone_updated": "Phone number updated successfully, Please enter verification code sent to the new phone number",
    "invalid_first_name": `${ctx.firstName}  is not accepted as a valid first name. Please correct it and try again.`,
    "invalid_last_name": `${ctx.lastName} is not accepted as a valid last name. Please correct it and try again.`,
    "invalid_email_format": `${ctx.email} is not a valid email address. Please review or use a different email address and try again.`,
    "email_already_used": `${ctx.email} is already used by another account. You might try logging in instead?`,
    "invalid_phonenumber": `${ctx.phone} is not a valid phone number. Please review or use a different phone number and try again.`,
    "phone_already_used": `${ctx.phone} is already used by another account. You might try logging in instead?`,
    "invalid_password": "Your password is not strong enough. Please try a stronger password.",
    "invalid_email_code": "You entered a wrong code.",
    "invalid_sms_code": "You entered a wrong code.",
    "something_went_wrong": "Something went wrong. Please try again later.",
    "email_validation_failed": "Email validation failed.",
    "phone_number_validation_failed": "Phone number validation failed",
    "finishing_registration_failed": "Finishing registration failed.",
    "verify_email_and_phone_number": "Verify email",
    "validation_failure": "Validation failure!",
    "passwords_do_not_match": "Passwords do not match!",
    "sms_resent": "Another sms was sent to your phone",
    "email_resent": "Another Verification Email was sent to your inbox",
    "validate_email_and_phonenumber": "Verification code is sent to your email to validate your ownership. Fill in the code in the box below your email"
  }
  return strings[key]
}